var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAssetsLightTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.244,
    height: 29.887,
    viewBox: "0 0 82.244 29.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_assets_light_truck",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M782.684,192.677h-.036a7.46,7.46,0,0,0-.033,14.92h.035a7.46,7.46,0,0,0,.034-14.92Zm-.053,10.782h-.019a3.324,3.324,0,0,1,.055-6.647h.018a3.324,3.324,0,0,1-.054,6.647Z",
    transform: "translate(-716.143 -178.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M103.127,196.477h-.033a7.46,7.46,0,0,0-.031,14.921h.033a7.46,7.46,0,0,0,.031-14.921Zm-.052,10.783h-.015a3.324,3.324,0,0,1,.055-6.647h.015a3.324,3.324,0,0,1-.055,6.647Z",
    transform: "translate(-88.35 -181.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M313.224,288.094a.556.556,0,0,0,.573.6h28.6a.886.886,0,0,0,.914-.85v-1.237H313.2c.014.21.03,1.271.029,1.485",
    transform: "translate(-289.339 -264.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M708.531,286.6h0Z",
    transform: "translate(-654.562 -264.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M81.829,16.851h0c-.251,0-.5-.41-.5-.914V8.611a1.966,1.966,0,0,0-1.84-1.851H54.865L53.343.9A1.15,1.15,0,0,0,52.259,0H30.34a3.062,3.062,0,0,0-1.63.568L21.845,5.316a3.715,3.715,0,0,1-1.626.662L4.825,7.58a7.051,7.051,0,0,0-1.747.462l-.409.179a1.523,1.523,0,0,0-.831,1.245h-.01a.917.917,0,0,0-.914.914v6.17A.917.917,0,0,0,0,17.464v2.881a1.091,1.091,0,0,0,.914,1.03H5.639s.064-.313.115-.594a9.137,9.137,0,0,1,18.065.593H53.969v-.005l3.438.005a9.133,9.133,0,0,1,18.2,0c.351-.023.707.038.972,0h4.8a.94.94,0,0,0,.862-.935V17.481c0-.5-.163-.63-.414-.63M41.118,1.231h8.623a1.1,1.1,0,0,1,1.051.9l.891,4.581a.764.764,0,0,1-.777.9H41.118ZM23.779,10.388a.917.917,0,0,1-.914-.914V7.564a2.191,2.191,0,0,1,.708-1.492l5.9-4.264A2.991,2.991,0,0,1,31.1,1.23h8.231V7.619H33.852a1.96,1.96,0,0,0-1.433.752l-.872,1.264a1.954,1.954,0,0,1-1.433.752Zm54.358-.106h-42.6l-4.8,4.8a.571.571,0,1,1-.808-.808l5.132-5.132H78.136a.571.571,0,1,1,0,1.143",
    transform: "translate(0 0.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssetsLightTruck);
export default __webpack_public_path__ + "static/media/icon_assets_light_truck.d87e9766daee4f6f50206ca8d3902d93.svg";
export { ForwardRef as ReactComponent };